import { render } from "./AppPhotoUpload.vue?vue&type=template&id=24b6c22d&scoped=true"
import script from "./AppPhotoUpload.vue?vue&type=script&lang=js"
export * from "./AppPhotoUpload.vue?vue&type=script&lang=js"

import "./AppPhotoUpload.vue?vue&type=style&index=0&id=24b6c22d&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b6c22d"]])

export default __exports__